/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Toast_Customer_Debt_Payment_SuccessInputs */

const vi_toast_customer_debt_payment_success = /** @type {(inputs: Toast_Customer_Debt_Payment_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tạo phiếu thu thành công`)
};

/**

* @param {Toast_Customer_Debt_Payment_SuccessInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const toast_customer_debt_payment_success = /** @type {((inputs?: Toast_Customer_Debt_Payment_SuccessInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toast_Customer_Debt_Payment_SuccessInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_toast_customer_debt_payment_success(inputs)
});